import { AudioSubtitle } from './AudioSubtitle';

export default AudioSubtitle;
